import * as React from "react";
import "./CommentTooltip.styl";

export default class CommentTooltip extends React.PureComponent<{
    label: string;
}> {

    public render(): React.ReactNode {
        return (
            <div className="Discussion-CommentTooltip-Root">
                <div className="Discussion-CommentTooltip-Body">
                    {this.props.label}
                </div>
                <div className="Discussion-CommentTooltip-Arrow"/>
            </div>
        );
    }

}